export const redirectPolicy = link => {
  console.log(link, '!!!!!!!!!!!!!');
  try {
    const { pathname } = new URL(link)
    window.location.pathname = pathname
  } catch (e) {
    window.location.pathname = link
  }
}
